import { Col } from "react-bootstrap";

const FieldLabelCol = ({ label, hasErrorMsg }) => {
  return (
    <Col sm={12} md={2} className={hasErrorMsg ? "text-danger" : ""}>
      {label}:{hasErrorMsg && <div className="fw-bold">*{hasErrorMsg}</div>}
    </Col>
  );
};
export default FieldLabelCol;
